import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Logo from "../../images/VAngov.webp";
import LogoDark from "../../images/VAngovDark1.webp";
import GitlabLogo from "./../../images/gitlab.webp";
import GithubLogoDark from"./../../images/icons8-github-48.svg";
import GithubLogoLight from"./../../images/icons8-github-100.svg";
import { MoonIcon, SunIcon } from "@heroicons/react/20/solid";

const navItems = ["Home", "Projects", "Team-Projects"];

interface Props {
  theme: boolean;
  setTheme: React.Dispatch<React.SetStateAction<boolean>>;
}
export const NavBar = ({ setTheme, theme }: Props) => {
  const { pathname } = useLocation();
  const [expandMenu, setExpandMenu] = useState<boolean>(false);

  return (
    <nav
      className="border-gray-200 px-2 sm:px-4 py-2.5 bg-lightgreen dark:bg-gray-900"
      onClick={() => {
        expandMenu && setExpandMenu(!expandMenu);
      }}
    >
      <div
        className={`absolute top-60 right-0 ${
          pathname !== "/" && pathname !== "/home"
            ? `z-[1] w-[25%] h-[50%] ${
                theme ? "pink__gradient" : "green__gradient"
              }`
            : ""
        }`}
      />
      <div className="container flex flex-wrap md:flex-nowrap items-center justify-between mx-auto">
        <Link to="/" className="flex logo items-center">
          <img
            src={theme ? Logo : LogoDark}
            className="h-9 mr-3 sm:h-12"
            alt="Personal logo"
          />
        </Link>
        <div className="flex md:order-2">
          <div className="mr-4 self-center md:ml-10 cursor-pointer">
            {!theme && (
              <MoonIcon
                onClick={() => {
                  setTheme(!theme);
                  localStorage.setItem("theme", "sun");
                }}
                className={"w-6 text-gray-900"}
              />
            )}
            {theme && (
              <SunIcon
                onClick={() => {
                  setTheme(!theme);
                  localStorage.setItem("theme", "moon");
                }}
                className={"w-6 text-white"}
              />
            )}
          </div>
          <button
            onClick={() => setExpandMenu(!expandMenu)}
            data-collapse-toggle="navbar-search"
            type="button"
            className={`inline-flex items-center p-2 text-sm  rounded-lg md:hidden  focus:outline-none  ${
              theme
                ? "text-gray-200 hover:bg-gray-700 "
                : "text-gray-900  hover:bg-lightgreen"
            }`}
            aria-controls="navbar-search"
            aria-expanded={expandMenu}
          >
            <span className="sr-only">Open menu</span>
            <svg
              className="w-6 h-6"
              aria-hidden="true"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                clipRule="evenodd"
              ></path>
            </svg>
          </button>
        </div>
        <div
          className={`items-center justify-between ${
            !expandMenu && "hidden"
          } w-full md:flex md:w-auto grow md:order-1`}
          id="navbar-search"
        >
          <ul className="navbar-ul flex flex-col mx-auto p-4 mt-4 dark:border rounded-lg  md:flex-row md:space-x-8 md:mt-0 md:text-sm md:font-medium md:border-0 md:bg-white bg-lightgreen dark:bg-gray-800 md:bg-lightgreen dark:md:bg-gray-900 border-gray-900">
            {navItems.map((item) => (
              <li key={item}>
                <Link
                  to={`/${item.toLowerCase()}`}
                  className="w-full block py-2 pl-3 pr-4 rounded  hover:bg-gray-100 md:hover:bg-transparent md:hover:text-blue-700 md:p-0  text-gray-900 dark:text-gray-200 md:hover:text-white hover:bg-gray-900 hover:text-white md:hover:bg-transparent border-gray-700"
                >
                  {item}
                </Link>
              </li>
            ))}
            <li>
              <a
                className="block py-2 pl-3 pr-4 rounded hover:bg-gray-100 md:hover:bg-transparent md:hover:text-blue-700 md:p-0  text-gray-900 dark:text-gray-200 md:hover:text-white hover:bg-gray-900 hover:text-white md:hover:bg-transparent border-gray-700"
                target="_blank"
                rel="noopener noreferrer"
                href="https://guess-number-in-five-moves.netlify.app/"
              >
                Play-Game
              </a>
            </li>
          </ul>
          <div className="flex justify-center mt-3 md:mt-0 items-center space-x-2">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.facebook.com/Vangel.a.k.a.Try2Fly"
              className="inline-block px-6 py-2.5 text-white font-medium text-xs bg-gray-900 dark:bg-gray-600 leading-tight uppercase rounded shadow-md hover:bg-gray-500 focus:shadow-lg focus:outline-none focus:ring-0 active:shadow-lg transition duration-150 ease-in-out"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 320 512"
                className="w-4 h-4"
              >
                <path
                  fill="currentColor"
                  d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"
                />
              </svg>
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.linkedin.com/in/vangel-angov-ba6b62241"
              className="inline-block bg-gray-900 dark:bg-gray-600 px-6 py-2.5 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-gray-500 focus:shadow-lg focus:outline-none focus:ring-0 active:shadow-lg transition duration-150 ease-in-out"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 448 512"
                className="w-4 h-4"
              >
                <path
                  fill="currentColor"
                  d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"
                />
              </svg>
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://gitlab.com/angov.vangel"
              data-mdb-gitlab="true"
              className="bg-gray-900 dark:bg-gray-600 inline-block px-6 py-2.5 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-gray-500 focus:shadow-lg focus:outline-none focus:ring-0 active:shadow-lg transition duration-150 ease-in-out"
            >
              <div className="w-4 h-4">
                <img
                  className="w-full block"
                  src={GitlabLogo}
                  alt="gitlab-logo"
                />
              </div>
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://github.com/vangelAngov"
              className="bg-gray-900 dark:bg-gray-600 inline-block px-6 py-2.5 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-gray-500 focus:shadow-lg focus:outline-none focus:ring-0 active:shadow-lg transition duration-150 ease-in-out"
            >
              <div className="w-4 h-4">
                <img
                  className="w-full block"
                  src={theme ? GithubLogoDark : GithubLogoLight}
                  alt="github-logo"
                />
              </div>
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
};
